import React from "react";
import BestBuyHomePage from "../assets/portfolio/BestBuyHomePage.jpg";


const Project = () => {
  const project = [
    {
      id: 1,
      src: BestBuyHomePage,
      href:"https://moonlit-druid-960309.netlify.app",
      href1:"https://github.com/Piryanshu88/BestBuys_Clone"
    },
    {
      id: 2,
    //   src: reactParallax,
    },
    
  ];

  return (
    <div
      name="project"
      className="bg-gradient-to-b from-teal-900 to-black w-full text-white md:h-screen"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Project
          </p>
          <p className="py-6">Check out some of my work right here</p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0">
          {project.map(({ id, src ,href,href1}) => (
            <div key={id} className="shadow-md shadow-gray-600 rounded-lg">
              <img
                src={src}
                alt=""
                className="rounded-md duration-200 hover:scale-105"
              />
              <div className="flex items-center justify-center">
                <a href={href} target="_blank" rel="noreferrer"><button  className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105">
                  Demo
                </button></a>
                <a href={href1} target="_blank" rel="noreferrer"><button className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105">
                  Code
                </button></a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Project;